/**
 * If the URL contains #universalLink displays a link at the bottom
 * with the universal link
 */
function showUniversalLink() {
    if (document.location.hash.includes('universalLink')) {
        let link = $('.universalLink').first().data('link');
        if (link) {
            link += document.location.search;
            $('body').append(`<a href="${link}" >${link}</a>`);
        }
    }
}

/**
 * Remove ul parameter if it is the only one
 */
function removeUniversalLinkParam() {
    if (window.location.toString().match(/\?ul$/)) {
        window.history.replaceState(null, null, window.location.toString().replace('?ul', ''));
    }
}
/**
 * Page loaded
 */
function init() {
    showUniversalLink();
    removeUniversalLinkParam();
}

module.exports = {
    init
};
